import { useDocumentationCard } from '../../building-blocks/documentation-card/useDocumentationCard';
import { SalesforceItem } from '../../../parser/ConfigurationItemTypes';
import { useSelector } from 'react-redux';
import { selectSaltoObjectTypes } from '../../../../reducers/global/parserReducer';
import { DocumentationCardHeaderLayout } from '../../building-blocks/documentation-card/DocumentationCardHeaderLayout';
import { SfConfigTitle } from './atoms/SfConfigTitle';

interface CommentHeaderProps {
  configurationItem: SalesforceItem;
  parentType: string;
  crmOrgId: string;
}

export const CommentHeader = ({ configurationItem, parentType, crmOrgId }: CommentHeaderProps) => {
  const { onGoBackInHistory } = useDocumentationCard();
  const saltoObjectTypes = useSelector(selectSaltoObjectTypes(crmOrgId));

  return (
    <DocumentationCardHeaderLayout
      title={
        <SfConfigTitle
          configurationItem={configurationItem}
          type={parentType}
          saltoObjectTypes={saltoObjectTypes ?? []}
        />
      }
      onGoBack={onGoBackInHistory}
      shouldDisplayBackButton
    />
  );
};
